import { useRouter } from "next/router";
import { useTranslation } from "@/lib/translations";
import {
  OpenPositionCardContainer,
  Info,
  Country,
  Title,
  Description,
  LinkContainer,
  ButtonStyled,
} from "./styles";

// TODO fix types (? vs null)
export type OpenPositionCardProps = {
  id: number | null;
  title: string | null;
  subtitle: string | null;
  description_html: string | null;
  description_txt: string | null;
  opening_date: string | null;
  closing_date: string | null;
  node: string;
  node_id: number;
  location: {
    country?: string;
    city?: string;
    province?: string;
    address?: string;
    coordinates?: {
      latitude?: string;
      longitude?: string;
    };
  };
  resource_url: string;
  web_url: string;
};

const OpenPositionCard: React.FC<OpenPositionCardProps> = (props) => {
  const { locale = "it" } = useRouter();
  const { location, title, description_txt, web_url } = props;

  const country = location?.country;
  const getCountryNames = new Intl.DisplayNames([locale], {
    type: "region",
  });
  const countryDisplayName = country && getCountryNames.of(country);

  const t = {
    apply: useTranslation("position.apply", locale) || "",
  };

  const description = shorten(description_txt, 180, " ").concat("...");
  // https://stackoverflow.com/a/40382963 (or use lodash truncate)
  // Shorten a string to less than maxLen characters without truncating words.
  function shorten(str: string | null, maxLen: number, separator = " ") {
    if (!str) return "";
    if (str.length <= maxLen) return str;
    return str.substr(0, str.lastIndexOf(separator, maxLen));
  }

  return (
    <OpenPositionCardContainer>
      <Info>
        {countryDisplayName && <Country>{countryDisplayName}</Country>}
        {title && <Title as="h2">{title}</Title>}
        {description && <Description>{description}</Description>}
      </Info>
      <LinkContainer>
        <ButtonStyled as="a" href={web_url} target={"_blank"}>
          {t.apply}
        </ButtonStyled>
      </LinkContainer>
    </OpenPositionCardContainer>
  );
};

export default OpenPositionCard;
